module.exports = __webpack_public_path__ + "static/media/select-input-preview.a878b16d.png";